const withoutTemplatesFromGroup = groupId => prevTemplates =>
    prevTemplates.filter(template => template.group.id !== groupId);

export default withoutTemplatesFromGroup;
